import PageGlobalError from 'hcp/components/page/global-error';

<template>
  <main id="content">
    <PageGlobalError
      @variant="authentication-callback-failure"
      @error={{@controller.model}}
    />
  </main>
</template>
